<ui-bottom-sheet
  appBackClose
  [open]="isOpen()"
  [title]="'SIDEBAR.ORGANIZATION' | translate"
  [stableHeight]="true"
  sheetHeight="min(80vh, 100dvh)"
  (closeEmit)="onClose()"
>
  @if (userOrganizations().length > 10) {
    <ui-search
      sheet-search
      [placeholder]="'SIDEBAR.SEARCH_ORGANIZATION_PLACEHOLDER' | translate"
      [heightPx]="40"
      [debounceMs]="0"
      [ngModel]="searchQuery()"
      (ngModelChange)="searchQuery.set($event)"
    ></ui-search>
  }

  <div sheet-content class="org-selector-content">
    @let organizations = filteredOrganizations();
    @let query = searchQuery().trim();
    @if (!organizations.length && query) {
      <ui-sheet-empty-state
        [query]="query"
        emptyIconClass="ui-icon-company"
        (clear)="searchQuery.set('')"
      />
    } @else {
      <div class="sheet-options-list org-list" role="listbox">
        @if (!query && activeOrganization(); as active) {
          <div
            class="sheet-option org-row selected"
            role="option"
            aria-selected="true"
          >
            <ui-avatar
              class="org-avatar"
              [name]="active.settings.orgName"
              [color]="active.settings.orgColor"
            ></ui-avatar>
            <span class="sheet-option-text">
              <span class="option-label">{{ active.settings.orgName }}</span>
              <span class="sheet-option-sub">{{
                'SIDEBAR.CURRENT' | translate
              }}</span>
            </span>
            <span
              class="sheet-option-check ui-icon-checkmark"
              aria-hidden="true"
            ></span>
          </div>
        }
        @for (org of organizations; track org.id) {
          <div
            class="sheet-option org-row"
            role="option"
            tabindex="0"
            aria-selected="false"
            (click)="onSelectOrganization(org)"
            (keydown.enter)="onSelectOrganization(org)"
          >
            <ui-avatar
              class="org-avatar"
              [name]="org.name"
              [color]="org.color"
            ></ui-avatar>
            <span class="option-label">{{ org.name }}</span>
          </div>
        }
      </div>
    }
  </div>
</ui-bottom-sheet>
